export default "__VITE_ASSET__a79288fc__"